import IMask from 'imask';
import lightGallery from 'lightgallery';
import lgFullscreen from 'lightgallery/plugins/fullscreen';
import { Modal } from 'bootstrap/js/dist/modal';
import { OffCanvas } from 'bootstrap/js/dist/offcanvas';
import { Tab } from 'bootstrap/js/dist/tab';

import AOS from 'aos';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

import Swiper from 'swiper';
import {
  Navigation,
  Pagination,
  EffectFade,
  Autoplay,
  Mousewheel,
  EffectCards,
} from 'swiper/modules';

Swiper.use([
  Navigation,
  Pagination,
  EffectFade,
  Autoplay,
  Mousewheel,
  EffectCards,
]);

// Инициализация при загрузке DOM-дерева
document.addEventListener('DOMContentLoaded', () => {
  initTelMasks();
  initLightGalleries();
  initSliderBlogShort();
  initSliderOurProjects();
  initSliderFeedbacks();
  initSliderProjects();
  initSliderReviews();
  initSliderTeammates();
  initSliderTextFeedbacks();
  initSliderCards();

  initCheckScrollBlock();

  initModalChangeble();

  initScrollTriggerWaranty();
  initScrollTriggerBigLetters();
  if (document.querySelector('.run-letters')) {
    initRunningText();
  }

  if (document.querySelector('#map')) {
    let myMap;
    ymaps.ready(function () {
      // Создаем кастомный тип карты с нашими стилями
      var myMapType = new ymaps.MapType('myStyle', [
        {
          featureType: 'all',
          elementType: 'geometry',
          stylers: [
            { lightness: '0' },
            { saturation: '0' },
            { hue: '#ffffff' },
          ],
        },
        {
          featureType: 'all',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#5f666d' }],
        },
        {
          featureType: 'all',
          elementType: 'labels.text.stroke',
          stylers: [
            { color: '#ffffff' },
            { visibility: 'on' },
            { lightness: '16' },
          ],
        },
        {
          featureType: 'administrative',
          elementType: 'geometry',
          stylers: [{ color: '#8c8c8c' }],
        },
        {
          featureType: 'administrative.country',
          elementType: 'geometry',
          stylers: [{ color: '#8c8c8c' }],
        },
        {
          featureType: 'administrative.province',
          elementType: 'geometry',
          stylers: [{ color: '#8c8c8c' }],
        },
        {
          featureType: 'landscape',
          elementType: 'geometry',
          stylers: [{ color: '#e1e3e4' }],
        },
        {
          featureType: 'landscape.natural.terrain',
          elementType: 'geometry',
          stylers: [{ color: '#e1e3e5' }],
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [{ color: '#e1e3e5' }],
        },
        {
          featureType: 'poi',
          elementType: 'labels',
          stylers: [{ visibility: 'off' }],
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [{ color: '#ffffff' }],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [{ color: '#ffffff' }],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#c8ccd0' }],
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry',
          stylers: [{ color: '#ffffff' }],
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#c8ccd0' }],
        },
        {
          featureType: 'road.local',
          elementType: 'geometry',
          stylers: [{ color: '#ffffff' }],
        },
        {
          featureType: 'road.local',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#c8ccd0' }],
        },
        {
          featureType: 'transit',
          elementType: 'geometry',
          stylers: [{ color: '#dcdee0' }],
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [{ color: '#adb4bb' }],
        },
        {
          featureType: 'water',
          elementType: 'labels.text',
          stylers: [{ color: '#5e6871' }],
        },
      ]);

      myMap = new ymaps.Map(
        'map',
        {
          center: [55.819909, 37.601],
          zoom: 16,
          controls: ['zoomControl', 'fullscreenControl'],
        },
        /* {
          mapType: myMapType,
        }, */
      );

      // Добавляем метку
      var myPlacemark = new ymaps.Placemark(
        [55.819909, 37.6025],
        {
          hintContent: 'Отделка+',
          //balloonContent: 'Это текст балуна',
        },
        {
          iconLayout: 'default#image',
          iconImageHref:
            'https://cdn-icons-png.flaticon.com/512/684/684908.png',
          iconImageSize: [40, 40],
          iconImageOffset: [-20, -40],
        },
      );

      myMap.geoObjects.add(myPlacemark);
    });
  }

  AOS.init({
    // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
    offset: 150, // offset (in px) from the original trigger point
    once: false, // whether animation should happen only once - while scrolling down
    mirror: true, // whether elements should animate out while scrolling past them
    anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
  });
});

function initScrollTriggerWaranty() {
  gsap.utils.toArray('.scroll-trigger-circle').forEach((circle, i) => {
    gsap.to(circle, {
      rotation: -360 * 0.5,
      ease: 'none',
      scrollTrigger: {
        trigger: circle, // Уникальный триггер для каждого элемента
        start: 'top bottom', // Старт при достижении верха элемента центра экрана
        end: 'bottom top', // Конец при достижении низа элемента центра экрана
        scrub: true,
        // markers: true // Для отладки позиций
      },
    });
  });
}

function initScrollTriggerBigLetters() {
  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: '.block-big-letters',
      start: 'top bottom-=30%',
      end: 'bottom top',
      scrub: 1,
      markers: false, // включите для отладки
    },
  });

  // Анимация для текста
  timeline
    .fromTo(
      '.block-big-letters__title--line-1',
      { x: '50vw', opacity: 0 },
      { x: '0', opacity: 1, ease: 'ease' },
      0,
    )
    .fromTo(
      '.block-big-letters__title--line-2',
      { x: '50vw', opacity: 0 },
      { x: '6vw', opacity: 1, ease: 'ease' },
      0.2,
    );

  // Анимация для штампа
  timeline.to(
    '.block-big-letters__stamp',
    {
      rotation: 360,
      ease: 'ease',
    },
    0,
  );

  // Анимация для медиа
  timeline.fromTo(
    '.block-big-letters__media img',
    {
      y: '100%',
      scale: 0.7,
      filter: 'blur(0px)',
      opacity: 0.5,
    },
    {
      y: '-100%',
      scale: 2,
      filter: 'blur(0)',
      opacity: 1,
      ease: 'none',
      duration: 1.5,
    },
    0.4,
  );
}

function initRunningText() {
  const container = document.querySelector('.run-letters');
  if (!container) return;

  // Клонируем все элементы
  const originalItems = container.querySelectorAll('.run-letters__item');
  originalItems.forEach((item) => {
    const clone = item.cloneNode(true);
    clone.classList.add('clone');
    container.appendChild(clone);
  });

  // Вычисляем общую ширину оригинальных элементов
  let totalWidth = 0;
  originalItems.forEach((item) => {
    totalWidth += item.offsetWidth;
  });

  // Добавляем gap к общей ширине
  const gap = parseFloat(getComputedStyle(container).gap) || 0;
  totalWidth += gap * (originalItems.length - 1);

  // Создаем анимацию
  gsap.to(container, {
    x: -totalWidth,
    duration: 45,
    repeat: -1,
    ease: 'linear',
    modifiers: {
      x: gsap.utils.unitize((x) => parseFloat(x) % totalWidth),
    },
  });
}

// Функция инициализации масок телефонных номеров
function initTelMasks() {
  const telInputs = document.querySelectorAll('input[type=tel]');
  telInputs.forEach((el) => {
    IMask(el, {
      mask: '+{7} 000 000 00 00',
    });
  });
}

// Функция инициализации галерей изображений
function initLightGalleries() {
  const galleryElements = document.querySelectorAll('[data-gallery]');
  galleryElements.forEach((el) => {
    lightGallery(el, {
      licenseKey: '0000 0000 0000 0000',
      download: false,
      fullScreen: false,
      plugins: [lgFullscreen],
      selector: '[data-src]',
    });
  });
}

function initSliderBlogShort() {
  const sliderBlogShort = new Swiper('.slider-blog-short', {
    spaceBetween: 16,
    slidesPerView: 3,
    speed: 400,
    watchSlidesProgress: true,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true,
      dynamicMainBullets: 3,
    },

    breakpoints: {
      0: {
        slidesPerView: 'auto',
        spaceBetween: 8,
      },
      576: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      992: {
        slidesPerView: 3,
      },
    },
  });
}

function initSliderOurProjects() {
  const sliderOurProjects = new Swiper('.slider-our-projects', {
    spaceBetween: 16,
    slidesPerView: 2,
    speed: 400,
    watchSlidesProgress: true,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    breakpoints: {
      0: {
        slidesPerView: 'auto',
        spaceBetween: 8,
      },
      576: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      992: {
        slidesPerView: 2,
      },
    },
  });
}

function initSliderReviews() {
  const sliderBlogShort = new Swiper('.slider-reviews', {
    spaceBetween: 16,
    slidesPerView: 3,
    speed: 400,
    watchSlidesProgress: true,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    breakpoints: {
      0: {
        slidesPerView: 'auto',
        spaceBetween: 8,
      },
      576: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      },
    },
  });
}

function initSliderTeammates() {
  const sliderTeammates = new Swiper('.slider-teammates', {
    spaceBetween: 16,
    slidesPerView: 3,
    speed: 400,
    watchSlidesProgress: true,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    breakpoints: {
      0: {
        slidesPerView: 'auto',
        spaceBetween: 8,
      },
      576: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      },
    },
  });
}

function initSliderProjects() {
  const sliderProjects = new Swiper('.slider-projects', {
    spaceBetween: 16,
    slidesPerView: 'auto',
    speed: 400,
    watchSlidesProgress: true,

    /*  mousewheel: {
      enabled: true,
      releaseOnEdges: true,
    }, */

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true,
      dynamicMainBullets: 5,
    },

    breakpoints: {
      0: {
        spaceBetween: 8,
      },
      576: {
        spaceBetween: 16,
      },
    },
  });
}
function initSliderFeedbacks() {
  const sliderFeedbacks = new Swiper('.slider-feedbacks', {
    spaceBetween: 16,
    slidesPerView: 1,
    speed: 400,
    watchSlidesProgress: true,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
}

function initSliderTextFeedbacks() {
  const sliderTextFeedbacks = new Swiper('.slider-text-feedbacks', {
    spaceBetween: 16,
    slidesPerView: 'auto',
    speed: 400,
    watchSlidesProgress: true,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
}

function initSliderCards() {
  const sliderCards = new Swiper('.slider-cards', {
    loop: true,
    effect: 'cards',
    grabCursor: true,
    speed: 400,

    autoplay: {
      delay: 5000,
    },

    cardsEffect: {
      rotate: 15,
      perSlideRotate: 8,
      slideShadows: true,
      perSlideOffset: 15,
    },
  });
}

// Экспорт модального окна для доступа извне
window.modal = Modal;

function initCheckScrollBlock() {
  const trigerBlock = document.querySelector('[data-block-triger-scroll]');
  if (!trigerBlock) {
    return;
  }

  let hasTriggered = false; // Флаг для отслеживания, был ли уже выполнен клик

  window.addEventListener('scroll', (e) => {
    if (isElementInViewport(trigerBlock) && !hasTriggered) {
      gsap.to(window, {
        duration: 0.5,
        scrollTo: {
          y: '#sec-second',
          offsetY: 50,
          autoKill: false,
        },
        ease: 'none',
        onComplete: () => {
          //console.log('Прокрутка выполнена.');
        },
      });

      hasTriggered = true; // Устанавливаем флаг после первого клика
    } else if (window.scrollY === 0) {
      hasTriggered = false; // Сбрасываем флаг, если пользователь прокрутил вверх
    }
  });
}

function isElementInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

// Функция инициализации изменяемых модальных и offcanvas окон
function initModalChangeble() {
  const modalChangebleEls = document.querySelectorAll('[data-modal-changeble]');

  modalChangebleEls.forEach((modalEl) => {
    /* show.bs.offcanvas | show.bs.modal */
    modalEl.addEventListener('show.bs.offcanvas', (event) => {
      const button = event.relatedTarget;
      const newTitle = button.getAttribute('data-modal-title');
      const newSubTitle = button.getAttribute('data-modal-subtitle');
      const whomInfo = button.getAttribute('data-whom');
      const newText = button.getAttribute('data-modal-text');
      const btnInnerText = button.getAttribute('data-modal-btn-text');

      const modalTitleEl = modalEl.querySelector('[data-modal-title]');
      const modalSubTitleEl = modalEl.querySelector('[data-modal-subtitle]');
      const modalTextEl = modalEl.querySelector('[data-modal-text]');
      const modalWhomEl = modalEl.querySelector('[data-whom]');
      const modalBtnEl = modalEl.querySelector('button[type=submit]');

      if (modalTitleEl && newTitle) {
        modalTitleEl.innerHTML = newTitle;
      }
      if (modalSubTitleEl && newSubTitle) {
        modalSubTitleEl.innerHTML = newSubTitle;
      }
      if (modalTextEl && newText) {
        modalTextEl.innerHTML = newText;
      }
      if (modalWhomEl && whomInfo) {
        modalWhomEl.value = whomInfo;
      }
      if (btnInnerText && modalBtnEl) {
        modalBtnEl.innerText = btnInnerText;
      }
    });
  });
}

/* 
document.addEventListener('DOMContentLoaded', () => {
  console.log('Локальные скрипты');

  const callbackFormEl = document.getElementById('callback-form');

  // Обработка формы обратной связи
  if (callbackFormEl) {
    callbackFormEl.addEventListener('submit', async function (e) {
      e.preventDefault();

      const formEl = this;
      const submitBtn = formEl.querySelector('button[type="submit"]');
      const messages = document.getElementById('form-messages');

      // Блокируем кнопку
      submitBtn.disabled = true;
      submitBtn.dataset.textbackup = submitBtn.textContent;
      submitBtn.textContent = 'Отправка...';
      messages.innerHTML = '';

      try {
        const formData = new FormData(formEl);
        formData.append('formit-send', '1');

        const response = await fetch(window.location.href, {
          method: 'POST',
          body: formData,
        });

        const result = await response.text();

        if (response.ok) {
          messages.innerHTML =
            '<div class="h2 mt-3">Спасибо!</div> <div class="h5">Ваше сообщение отправлено.</div>';
          formEl.reset();
        } else {
          throw new Error('Ошибка сервера');
        }
      } catch (error) {
        messages.innerHTML = `<div class="alert alert-danger mt-3">Ошибка отправки. Попробуйте еще раз. ${error}</div>`;
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.dataset.textbackup;
        console.log('Форма отправлена');

        if (document.querySelector('#show-email-result')) {
          document.querySelector('#show-email-result').click();
          console.log('Слово Спасибо показано.');
        }
      }
    });
  }

  console.log('Конец Локальные скрипты');
});

*/
